// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2RQ2i","colMin":"styles_colMin__20U4g"};